import { createSelector, createFeatureSelector } from '@ngrx/store';

export const sidebarSelector = createFeatureSelector<boolean>('sidebar');
export const getSidebarSelector = createSelector(sidebarSelector, (state: boolean) => state); 
